import { render, staticRenderFns } from "./flipusageelement.vue?vue&type=template&id=49f16ec1&"
import script from "./../../ts/articleattributes/flipusageelement.ts?vue&type=script&lang=js&"
export * from "./../../ts/articleattributes/flipusageelement.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports